/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Group, Paper, Space } from '@mantine/core';
import PageSection from '../../../../../../../components/core/PageSection/PageSection';
import { EventType, EventVehicleType } from '../../../../../../../models/core/events.type';
import { Feature } from '../../../../../../../utils/constants.utils';
import EventVehicleItem from './EventVehicleItem';
import EventVehiclePackagingView from './EventVehiclePackagingView';
import EventVehicleQuotation from './EventVehicleQuotation';

type DataViewProps = {
  data: EventVehicleType;
  event: EventType;
  zIndex: number;
};

export default function EventVehicleView(props: DataViewProps) {
  return (
    <div>
      <Paper shadow="xs" p="md" withBorder>
        <PageSection size="lg" color={Feature.Home.Event.color} label="Veículo" text="Detalhes do veículo." />
        <Space h="xs" />
        <EventVehicleItem data={props.data} />
      </Paper>
      <Space h="lg" />

      <Paper shadow="xs" p="md" withBorder>
        <Group justify="space-between">
          <PageSection
            size="lg"
            color={Feature.Home.Event.color}
            label="Fornecedor"
            text="Detalhes do fornecedor."
          />
        </Group>

        <Space h="xs" />
        <EventVehicleQuotation
          data={props.data.cotacao}
          compra={props.event.referencia!.contrato.residuo!.compra}
        />
      </Paper>
      <Space h="lg" />

      <Paper shadow="xs" p="md" withBorder>
        <PageSection
          size="lg"
          color={Feature.Home.Event.color}
          label="Acondicionamentos"
          text="Lista de acondicionamentos para este veículo."
        />

        <Space h="xs" />
        <EventVehiclePackagingView data={props.data.acondicionamentos} zIndex={props.zIndex + 1} />
      </Paper>
    </div>
  );
}
